import React from 'react';
import { Link } from 'react-router-dom';

const TermosDeUso: React.FC = () => {
  return (
    <div className="termos-de-uso">
      {/* Header */}
      <header className="bg-primary text-white py-3">
        <div className="container d-flex justify-content-between align-items-center">
          <Link to="/">
            <img src="/assets/images/logo-inplay.svg" alt="InPlay" height="40" />
          </Link>
          <button
            className="btn btn-secondary text-white"
            onClick={() => window.location.href = '/home'}
          >
            ACESSAR CONTA
          </button>
        </div>
      </header>

      {/* Content */}
      <div className="container py-5" style={{ maxWidth: '800px' }}>
        <h1 className="fw-bold mb-4">Termos de Uso</h1>
        <p className="text-muted mb-4">Última atualização: 22 de junho de 2026</p>

        <section className="mb-4">
          <h2 className="h5 fw-bold">1. Aceitação dos Termos</h2>
          <p>
            Ao acessar e utilizar a plataforma InPlay ("Plataforma"), você concorda com estes Termos de Uso.
            Caso não concorde com qualquer disposição, não utilize nossos serviços.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">2. Descrição do Serviço</h2>
          <p>
            A InPlay é uma plataforma digital para gestão de torneios esportivos, aluguel de quadras,
            rede social esportiva e organização de ligas. Nossos serviços incluem:
          </p>
          <ul>
            <li>Criação e gestão de torneios de Beach Tennis e outros esportes</li>
            <li>Inscrições e pagamentos online (PIX, cartão de crédito)</li>
            <li>Reserva e aluguel de quadras esportivas</li>
            <li>Rede social com posts, comentários e seguidores</li>
            <li>Rankings, estatísticas e acompanhamento de partidas</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">3. Cadastro e Conta</h2>
          <p>
            Para utilizar a Plataforma, é necessário criar uma conta com informações verdadeiras e atualizadas.
            Você é responsável pela segurança de suas credenciais de acesso e por todas as atividades
            realizadas em sua conta.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">4. Pagamentos e Reembolsos</h2>
          <p>
            Os pagamentos realizados na Plataforma são processados por meio de parceiros de pagamento
            (gateway Iugu). A InPlay atua como intermediária, facilitando transações entre atletas,
            organizadores e locais de quadras.
          </p>
          <p>
            Reembolsos seguem a política de cancelamento de cada torneio ou local de quadra,
            conforme configurado pelo organizador. Cancelamentos fora do prazo estabelecido
            podem estar sujeitos a multas ou perda do valor pago.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">5. Reserva de Quadras</h2>
          <p>
            Ao reservar uma quadra, você se compromete a comparecer no horário agendado.
            Reservas não pagas dentro do prazo de validade serão automaticamente canceladas.
            O valor do aluguel é definido pelo administrador do local.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">6. Conduta do Usuário</h2>
          <p>O usuário se compromete a:</p>
          <ul>
            <li>Não utilizar a Plataforma para fins ilegais ou não autorizados</li>
            <li>Não publicar conteúdo ofensivo, discriminatório ou que viole direitos de terceiros</li>
            <li>Não criar contas falsas ou se passar por outra pessoa</li>
            <li>Respeitar outros usuários, organizadores e atletas</li>
            <li>Não manipular resultados de partidas ou torneios</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">7. Propriedade Intelectual</h2>
          <p>
            Todo o conteúdo da Plataforma (textos, imagens, logotipos, código-fonte) é de propriedade
            da InPlay ou de seus licenciadores. É proibida a reprodução, distribuição ou modificação
            sem autorização prévia.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">8. Privacidade e Dados Pessoais</h2>
          <p>
            A InPlay coleta e trata dados pessoais em conformidade com a Lei Geral de Proteção de Dados (LGPD).
            Os dados coletados são utilizados para prestação dos serviços, melhoria da experiência
            e comunicações relevantes. Não compartilhamos dados com terceiros sem consentimento,
            exceto quando necessário para processamento de pagamentos.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">9. Limitação de Responsabilidade</h2>
          <p>
            A InPlay não se responsabiliza por:
          </p>
          <ul>
            <li>Cancelamentos ou alterações de torneios realizados por organizadores</li>
            <li>Condições das quadras ou instalações dos locais parceiros</li>
            <li>Disputas entre atletas, organizadores ou locais</li>
            <li>Indisponibilidade temporária da Plataforma por motivos técnicos</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">10. Modificações dos Termos</h2>
          <p>
            A InPlay reserva-se o direito de modificar estes Termos a qualquer momento.
            Alterações significativas serão comunicadas aos usuários. O uso continuado da Plataforma
            após modificações constitui aceitação dos novos termos.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">11. Rescisão</h2>
          <p>
            A InPlay pode suspender ou encerrar contas que violem estes Termos, sem aviso prévio.
            O usuário pode encerrar sua conta a qualquer momento entrando em contato com o suporte.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">12. Disposições Gerais</h2>
          <p>
            Estes Termos são regidos pelas leis da República Federativa do Brasil.
            Eventuais disputas serão resolvidas no foro da comarca de domicílio do usuário.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold">13. Contato</h2>
          <p>
            Em caso de dúvidas sobre estes Termos de Uso, entre em contato pelo e-mail:{' '}
            <a href="mailto:contato@inplayspts.me">contato@inplayspts.me</a>
          </p>
        </section>
      </div>

      {/* Footer */}
      <footer className="bg-primary text-white py-4">
        <div className="container text-center">
          <img src="/assets/images/logo-inplay.svg" alt="InPlay" height="30" className="mb-2" />
          <p className="mb-0">© InPlay 2026</p>
        </div>
      </footer>
    </div>
  );
};

export default TermosDeUso;
